import React from 'react';

import { useAuth0 } from "@auth0/auth0-react";

function Profile(props) { 
    const { user, isAuthenticated, isLoading } = useAuth0();

    if (isLoading) return <div>Loading...</div>;

    if (!isAuthenticated) {
        return <h2>You must be logged in to see this page.</h2>;
    }

    return (
        <div>
            <h1>Profile</h1>
            <img src={user.picture} alt={user.name} width="80" style={{ borderRadius: "50%" }} />
            <h2>{user.name}</h2>
            <p>{user.email}</p>
        </div>
    );
}
export default Profile;